import React, { useEffect } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { Card, CardBody, Col, Container, Form, FormGroup, Input, Row } from 'reactstrap';
import { Btn, H5 } from '../../AbstractElements';
import { useEditUser } from '../../hooks/manageUsers/useEditUser';
import { useLocation, useNavigate } from 'react-router-dom';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';

interface EditUserFormProps { }

export default function EditUserForm({ }: EditUserFormProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  const { handleEditUser, loading } = useEditUser();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstname: user?.firstname || '',
      lastname: user?.lastname || '',
      email: user?.email || '',
    },
  });

  useEffect(() => {
    if (user) {
      setValue('firstname', user.firstname);
      setValue('lastname', user.lastname);
      setValue('email', user.email);
    }
  }, [user, setValue]);

  const onSubmit: SubmitHandler<any> = async (data) => {
    await handleEditUser(user._id, data);
    navigate(`${process.env.PUBLIC_URL}/manage_users`);
  };

  return (

    <>
        <div className='page-body'>

      <Breadcrumbs pageTitle={"Edit User"} parent={"Manage User"} title={"Edit User"} />
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Card>
              <CardBody>
                <Form className="theme-form basic-form" onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col>
                      <FormGroup>
                        <H5 className="f-w-600 mb-2">First Name</H5>
                        <Controller
                          name="firstname"
                          control={control}
                          rules={{ required: 'First name is required' }}
                          render={({ field }) => (
                            <Input
                              className="form-control"
                              type="text"
                              placeholder="Enter first name"
                              {...field}
                            />
                          )}
                        />
                        {errors.firstname && (
                          <span style={{ color: 'red' }}>{String(errors?.firstname?.message)}</span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <FormGroup>
                        <H5 className="f-w-600 mb-2">Last Name</H5>
                        <Controller
                          name="lastname"
                          control={control}
                          rules={{ required: 'Last name is required' }}
                          render={({ field }) => (
                            <Input
                              className="form-control"
                              type="text"
                              placeholder="Enter last name"
                              {...field}
                            />
                          )}
                        />
                        {errors.lastname && (
                          <span style={{ color: 'red' }}>{String(errors?.lastname?.message)}</span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <FormGroup>
                        <H5 className="f-w-600 mb-2">Email</H5>
                        <Controller
                          name="email"
                          control={control}
                          rules={{
                            required: 'Email is required',
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: 'Invalid email address',
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              className="form-control"
                              type="email"
                              placeholder="Enter email"
                              {...field}
                            />
                          )}
                        />
                        {errors.email && (
                          <span style={{ color: 'red' }}>{String(errors?.email?.message)}</span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className="text-end">
                        <Btn
                          type="submit"
                          color="success"
                          className="me-3"
                          disabled={loading}
                        >
                          {loading ? 'Saving...' : 'Update'}
                        </Btn>
                        <Btn
                          type="button"
                          color="danger"
                          onClick={() => navigate(`${process.env.PUBLIC_URL}/manage_users`)}
                        >
                          Cancel
                        </Btn>
                      </div>
                    </Col>
                  </Row>
                </Form>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      </div>
    </>
  );
}